import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-too-long-meta-description',
    templateUrl: './too-long-meta-description.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoTooLongMetaDescriptionComponent {
}
